<div class="modal-header" ngbAutofocus>
    <h1 class="modal-title">Generate Signature</h1>
</div>
<div class="modal-body">
    <p>Are you sure you want to use this as your signature?</p>
    <p>By signing above, I agree that the signature and initials will be the electronic representation of my signature and initials for all purposes when I (or my agent) use them on documents, including legally binding contracts - just the same as a pen-and-paper signature or initial.</p>
    <img src="{{img}}" />
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-success" (click)="confirmClicked()">Confirm</button>
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>